import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import CustomButton from '@/components/CustomButton'

export default React.memo(function ChangeSuccess() {
    const navigate = useNavigate()
    const { t } = useTranslation()
    // 从 URL 查询参数读取验证码数据
    const handleSubmit = () => {
        navigate('/home')
    }
    return (
        <PageLayout>
            <Header leftChildren={<Back />} />
            {/* Content */}
            <div className='px-6 py-6'>
                <div className='flex flex-col justify-center items-center'>
                    <img className='w-50' src="/images/my/change-acount-success.png" />
                    <div className='text-center text-2xl mt-5 mb-12'>{t('验证成功')}</div>
                </div>
                <CustomButton
                    onClick={handleSubmit}
                >
                    {t('返回首页')}
                </CustomButton>
            </div>
        </PageLayout>
    )
})
